/** Voice categories for the picker's filter. Frontend-only UX grouping —
 *  the server still returns the flat voice list; this maps each preset voice
 *  id to one of three buckets so the user can narrow a long list. A voice id
 *  with no entry falls under "all" only (never hidden by a category filter).
 *  Labels are i18n (t.talkingAvatar.voiceCategoryNames.*). */
export type VoiceCategoryKey = "narration" | "marketing" | "cartoon";

/** Display order of the category filter buttons. */
export const VOICE_CATEGORY_ORDER: VoiceCategoryKey[] = [
  "narration",
  "marketing",
  "cartoon",
];

/** Which category each preset voice belongs to (by voice id). */
export const VOICE_CATEGORY_BY_ID: Record<string, VoiceCategoryKey> = {
  // Narration & stories
  sarah: "narration",
  bella: "narration",
  george: "narration",
  // Marketing & ads
  jessica: "marketing",
  brian: "marketing",
  liam: "marketing",
  // Cartoon characters
  stevie: "cartoon",
  gappu: "cartoon",
  littleDude: "cartoon",
  minnie: "cartoon",
  miffy: "cartoon",
};
